//Plugins
import axios from "axios";

//Rutas API
const rutaConsultarDatosHojaPrueba =
  "/api/Master/HojaPrueba/ObtenerDatosHojaPrueba";
const rutaActualizarDatosBasicos =
  "/api/Master/HojaPrueba/ActualizarDatosBasicos";

import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

export default {
  mixins: [mixinSolicitudInscripcion],
  methods: {
    CargarDatosHojaPrueba(prospectoId, tipoPersona) {
      if (prospectoId != null) {
        const parametroProspectoId = {
          params: {
            ProspectoId: prospectoId,
            TipoPersona: tipoPersona
          }
        };
        axios
          .get(rutaConsultarDatosHojaPrueba, parametroProspectoId)
          .then(resp => {
            if (resp.data.estado === 0) {
              this.solicitudExistenteId =
                resp.data.datosBasicosCliente.solicitudId;
              this.datosSolicitud.solicitudId =
                resp.data.datosBasicosCliente.solicitudId;
              this.datosSolicitud.fechaNacimiento =
                resp.data.datosSolicitud.fechaNacimiento != null
                  ? resp.data.datosSolicitud.fechaNacimiento.substring(0, 10)
                  : null;
              this.datosSolicitud.servicio = resp.data.datosSolicitud.servicio;
              this.datosBasicos.nombres =
                resp.data.datosBasicosCliente.datosProspecto.nombres;
              this.datosBasicos.apellidoPaterno =
                resp.data.datosBasicosCliente.datosProspecto.apellidoPaterno;
              this.datosBasicos.apellidoMaterno =
                resp.data.datosBasicosCliente.datosProspecto.apellidoMaterno;
              this.datosBasicos.monto =
                resp.data.datosBasicosCliente.datosProspecto.montoDeseado;
              if (tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7) {
                if (tipoPersona == 0 || tipoPersona == 3 || tipoPersona == 4 || tipoPersona == 6) {
                  this.datosSolicitudFisica.rfc =
                    resp.data.datosSolicitudFisica.rfc;
                } else {
                  this.datosSolicitudMoral.rfc =
                    resp.data.datosSolicitudMoral.rfc;
                  this.datosSolicitudMoral.lugarConstitucion =
                    resp.data.datosSolicitudMoral.lugarConstitucion;
                  this.datosSolicitudMoral.fechaInicioOperaciones = resp.data.datosSolicitudMoral.fechaInicioOperaciones.substring(
                    0,
                    10
                  );
                }
              }
              switch (this.tipoPersona) {
                case 0:
                case 3:
                case 4:
                case 6:
                  this.ConsultarUbicaciones(prospectoId);
                  this.ConsultarBeneficiariosTest();
                  break;
                case 1:
                  this.ConsultarUbicaciones(prospectoId);
                  //this.ConsultarBeneficiariosTest();
                  break;
                case 2:
                case 5:
                case 7:
                  this.ConsultarUbicacionesExtranjeras(prospectoId);
                  this.ConsultarBeneficiariosTest();
                  break;
              }
              //Puntos de contacto
              if (this.tipoPersona != 1) {
                this.PuntoContactoGeneral.correo1.valor =
                  resp.data.datosBasicosCliente.correoProspecto;
              }
              let arregloPuntos = resp.data.puntosDeContacto;
              for (var punto of arregloPuntos) {
                switch (punto.tipoContacto) {
                  case 0:
                  case 2:
                    if (this.tipoPersona != 1) {
                      this.PuntoContactoGeneral.telefonoFijo.puntoContactoId =
                        punto.puntoContactoId;
                      this.PuntoContactoGeneral.telefonoFijo.valor = punto.valor;
                    }
                    break;
                  case 1:
                    this.PuntoContactoGeneral.telefonoFijoOficina.puntoContactoId =
                      punto.puntoContactoId;
                    this.PuntoContactoGeneral.telefonoFijoOficina.valor =
                      punto.valor;
                    break;
                  case 4:
                    if (this.tipoPersona == 1) {
                      this.PuntoContactoGeneral.correoMoral.puntoContactoId =
                        punto.puntoContactoId;
                      this.PuntoContactoGeneral.correoMoral.valor = punto.valor;
                    }
                    break;
                }
              }
            } 
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    },
    //Actualización/Confirmación de datos básicos
    ActualizarDatosBasicos() {
      let ruta =
        rutaActualizarDatosBasicos +
        "?prospectoId=" +
        this.ProspectoId +
        "&nombre=" +
        this.datosBasicos.nombres +
        "&apellidoPaterno=" +
        this.datosBasicos.apellidoPaterno +
        "&apellidoMaterno=" +
        this.datosBasicos.apellidoMaterno +
        "&rfc=" +
        this.datosSolicitudFisica.rfc +
        "&servicio=" +
        this.datosSolicitud.servicio +
        "&fechaNacimiento=" +
        this.datosSolicitud.fechaNacimiento;
      axios
        .post(ruta)
        .then(() => {})
        .catch(e => this.ManejarExepcion(e));
    }
  }
};
